import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useFlattenDataAndUIConfig } from 'hooks/useFlattenDataAndUIConfig';
import { setIsLoading, setUiConfig } from 'stores/tasks/tasks';
import { ProcessSpecificationDTO, TaskBaseDTO } from 'support/types';

type UseInitialTaskSetupArgs = {
  actions: NonNullable<TaskBaseDTO['actions']> | undefined;
  initialData: ProcessSpecificationDTO['data'] | undefined;
};

export const useInitialTaskSetup = ({ actions, initialData }: UseInitialTaskSetupArgs) => {
  const { reset } = useFormContext();
  const { data, uiConfig, isLoading } = useFlattenDataAndUIConfig(actions, initialData);

  useEffect(() => {
    if (uiConfig) {
      setUiConfig(uiConfig);
    }

    if (data) {
      reset(data);
    }
  }, [data, reset, uiConfig]);

  useEffect(() => {
    setIsLoading(isLoading);
  }, [isLoading]);
};
